import React from "react";
import {Grid, Typography} from "@mui/material";
import {useLocation, useNavigate} from "react-router";
import Button from "@mui/material/Button";
import {routes} from "../routes";
import './NotFound.scss';

type Props = {msg?: React.ReactNode, noHomeButton?: boolean};
export const NotFound: React.FC<Props> = ({msg, noHomeButton}) => {
    const navigate = useNavigate();

    const location = useLocation();
    console.log('NotFound:', JSON.stringify(location));

    return (
        <div className="not-found-page">
            <Grid container justifyContent="center">
                <Grid>
                    <Typography variant="h3" component="h1">
                        Oops!
                    </Typography>
                    {msg && <Typography variant="body1" component="p">{msg}</Typography>}
                    {!noHomeButton && <Button variant="contained" color="primary" onClick={() => navigate(routes.home)}>
                        Go back to the homepage
                    </Button>}
                </Grid>
            </Grid>
        </div>
    );
};
